import React from 'react';
import { ProductColor } from '../../data/products';
import { productTheme } from '../../utils/productTheme';

interface ProductScreenshotProps {
  imageSrc: string;
  imageAlt: string;
  productName: string;
  color: ProductColor;
  urlLabel?: string;
  className?: string;
  loading?: 'lazy' | 'eager';
}

const ProductScreenshot: React.FC<ProductScreenshotProps> = ({
  imageSrc,
  imageAlt,
  productName,
  color,
  urlLabel = 'app.cimmple.com',
  className = '',
  loading = 'lazy',
}) => {
  const theme = productTheme(color);

  return (
    <div
      className={`rounded-2xl border bg-white dark:bg-dark-900 shadow-2xl overflow-hidden ${theme.screenshotFrame} ${className}`}
    >
      <div className={`flex items-center gap-2 px-4 py-3 border-b ${theme.screenshotChrome}`}>
        <div className="flex gap-1.5">
          <span className="w-3 h-3 rounded-full bg-red-400" />
          <span className="w-3 h-3 rounded-full bg-amber-400" />
          <span className="w-3 h-3 rounded-full bg-green-400" />
        </div>
        <div className="flex-1 flex justify-center">
          <span className="px-3 py-1 rounded-md bg-white dark:bg-dark-900 border border-slate-200 dark:border-dark-600 text-xs text-slate-500 dark:text-dark-400">
            {urlLabel}
          </span>
        </div>
        <span className={`text-xs font-semibold whitespace-nowrap ${theme.text}`}>
          {productName}
        </span>
      </div>
      <img src={imageSrc} alt={imageAlt} className="w-full h-auto block" loading={loading} />
    </div>
  );
};

export default ProductScreenshot;
